import { Languages, useCatalogSale } from '@landr/pricing';
import {
    DiscountedPlanDto,
    Interval,
    SaleDto,
} from '@landr/pricing/lib/types/generated';
import { useCallback } from 'react';

export type GetDiscountedPlan = ({
    planCode,
    frequency,
}: {
    planCode?: string;
    frequency?: Interval;
}) => DiscountedPlanDto | undefined;

export type UseCatalogSaleProps = {
    includePrismicContent?: boolean;
    language?: Languages;
};

export const useGetDiscountedPlan = (
    props?: UseCatalogSaleProps,
): {
    catalogSale: SaleDto | undefined;
    getDiscountedPlan: GetDiscountedPlan;
} => {
    const { data: catalogSale } = useCatalogSale(props);

    const discountedPlans = catalogSale?.discountedPlans;

    const getDiscountedPlan: GetDiscountedPlan = useCallback(
        ({ planCode, frequency }) => {
            if (!planCode || !frequency) {
                return undefined;
            }

            const discountedPlan = discountedPlans?.find(
                ({ plan }) =>
                    planCode &&
                    plan?.code === planCode &&
                    (!frequency || plan?.frequency === frequency),
            );

            return discountedPlan;
        },
        [discountedPlans],
    );

    return { catalogSale, getDiscountedPlan };
};
